import { render, staticRenderFns } from "./WorkforceList.vue?vue&type=template&id=e5f5f08e&"
import script from "./WorkforceList.vue?vue&type=script&lang=js&"
export * from "./WorkforceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports